import React from 'react';
import GaiAuth from '../GaiAuth';

export default function ServerVars(system) {
  return {
    wrapComponents: {
      Servers: WrappedServers,
    },
  };
}

const WrappedServers = (Servers, system) => props => {
  const gaiUrl = parseGaiUrl(
    props.getEffectiveServerValue(props.currentServer),
  );

  return (
    <>
      <Servers {...props} />
      {gaiUrl ? (
        <GaiAuth gaiUrl={gaiUrl} />
      ) : (
        <span>Not a Global App Infra URL. Unable to authenticate.</span>
      )}
    </>
  );
};

function parseGaiUrl(url) {
  if (!url) {
    return null;
  }
  const parsedUrl = new URL(url);
  if (parsedUrl.host.startsWith('services') && !url.includes('{')) {
    return parsedUrl.origin;
  }
  return null;
}
